import { TableCell } from "@mui/material"

export function AssetField({ asset, item: { field, format = (v) => v, align } }) {
    return (
        <TableCell align={align} data-cy={`asset-${field}-cell-content`}>
            {format(asset[field] ?? "")}
        </TableCell>
    )
}
